module.exports = __webpack_public_path__ + "static/media/ICONS-ENERGY.e53fde5a.svg";